/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/import-whitelist
import { announcementBannerSettingsV4Resource } from '@jira/admin-pages__system-announcement-banner-resources/src/useAnnouncementBannerSettingsV4Resource.tsx';
import { getConsentBannerUserPreferencesResource } from '@jira/router-resources__cookie-consent/src/useConsentBannerUserPreferencesResource.tsx';
import { incomingMailServerExpiryStatusResource } from '@jira/router-resources__incoming-mail-server-expiry-status/src/useIncomingMailExpiryStatus.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';

/**
 * Data for various banners that may or may not appear on page load. Eventually these should all disappear in to one of two places:
 *
 * 1. A top-level Jira SPA query, or
 * 2. A route-specific resource that gets rendered via a portal in to the banner location in page layout.
 *
 * @see `src/packages/platform/page-container-v2/src/common/ui/banner`
 */
export const getBannerResources = (): RouteResource[] => [
	getConsentBannerUserPreferencesResource(),
	announcementBannerSettingsV4Resource,
	incomingMailServerExpiryStatusResource,
];

/**
 * This is used in Work Item 2.0 to spread navigation banner resources conditionally to measure its performance.
 *
 * On cleanup of wi2-perf-banner-route-resource, revert to using `getBannerResources` directly in the route factory and remove this function.
 */
export const getConditionalBannerResources = (): RouteResource[] => [
	resourceWithCondition(
		() => fg('wi2-perf-banner-route-resource'),
		getConsentBannerUserPreferencesResource(),
	),
	resourceWithCondition(
		() => fg('wi2-perf-banner-route-resource'),
		announcementBannerSettingsV4Resource,
	),
	resourceWithCondition(
		() => fg('wi2-perf-banner-route-resource'),
		incomingMailServerExpiryStatusResource,
	),
];
